import { combineReducers } from "redux";
import { LeaveTypeReducer } from "./LeaveType/Reducer";
import { LeaveRequestReducer } from "./LeaveRequest/Reducer";
import { LeaveHistoryReducer } from "./LeaveHistory/Reducer"
import { LeaveReportsReducer } from "./LeaveReports/Reducer";
import { LeaveDashboardReducer } from "./LeaveDashboard/Reducer";
import { HolidayCalendarReducer } from "./HolidayCalendar/Reducer";
import { LeaveApprovalReducer } from "./ManageApproval/Reducer";
import { YearlyHolidayCalendarReducer } from "./YearlyHolidayCalendar/Reducer";
import { OptionalHolidayCalendarReducer } from "./OptionalHolidayCalendar/Reducer";
import { LeaveReasonReducer } from "./LeaveReason/Reducer";
import { LeaveYearTypeReducer } from "./LeaveYearType/Reducer";
import { MyTimeConfigureReducer } from "./MyTimeConfigure/Reducer";
import { CurrentTimeReducer } from "./MyTime/Reducer";
import { MyTimeSheetReducer } from "./MyTimeSheet/Reducer";
import { TimeSheetApprovalReducer } from "./MyTeam/Reducer";
import { WeekOffConfigureReducer } from "./WeekOff/Reducer";
import { ReportingEmployeeReducer } from "./ReportingEmployees/Reducer";
import { ShiftTimeConfigureReducer } from "./ShiftConfigure/Reducer";
import { AttendanceReducer } from "./AttendanceBulkNotationCode/Reducer";
import { AttendancePermissionReducer } from "./AttendancePermission/Reducer";
import { MyAttendancePermissionReducer } from "./MyAttendancePermission/Reducer";
import { MyAttendanceRegularizationReducer } from "./Regularization/Reducer";



const LeaveReducer = combineReducers({
    LeaveHistoryReducer,
    LeaveTypeReducer,
    LeaveRequestReducer,
    LeaveReportsReducer,
    LeaveDashboardReducer,
    HolidayCalendarReducer,
    LeaveApprovalReducer,
    YearlyHolidayCalendarReducer,
    OptionalHolidayCalendarReducer,
    LeaveReasonReducer,
    LeaveYearTypeReducer,
    MyTimeConfigureReducer,
    CurrentTimeReducer,
    MyTimeSheetReducer,
    TimeSheetApprovalReducer,
    WeekOffConfigureReducer,
    ReportingEmployeeReducer,
    ShiftTimeConfigureReducer,
    AttendanceReducer,
    AttendancePermissionReducer,
    MyAttendancePermissionReducer,
    MyAttendanceRegularizationReducer
});

export default LeaveReducer;